import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { EASE } from "./Hero";

const BRANDS = ["LG", "GE", "GE Profile", "GE Cafe", "Whirlpool", "Samsung"];

export default function Manifesto() {
    return (
        <section className="relative py-24 md:py-36">
            <div className="mx-auto max-w-[1440px] px-5 md:px-10">
                {/* 01 — THE PRICE PROMISE */}
                <div data-testid="manifesto-chapter-01" className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                    <Reveal className="lg:col-span-3">
                        <span className="font-serifed italic font-light text-gold text-7xl md:text-8xl leading-none">01</span>
                        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">
                            The Price Promise
                        </p>
                    </Reveal>
                    <div className="lg:col-span-9">
                        <Reveal delay={0.1}>
                            <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-5xl leading-[1.02] max-w-3xl">
                                Every price on our floor sits about{" "}
                                <span className="font-serifed italic text-gold">40%+ under</span> retail.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 max-w-2xl text-sm md:text-lg text-slate-300 leading-relaxed">
                                Not some prices. Not clearance models. Not last year's stock. Every
                                appliance we sell is compared against the retail price — and it
                                lands about 40% lower. Walk in with any store's quote and
                                watch what happens.
                            </p>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <div className="mt-10 max-w-xl border border-white/10 bg-ink2 p-6 md:p-8 clip-corner">
                                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                                    Example from the floor — GE 30" Gas Range, Model JGB735SPSS
                                </p>
                                <div className="mt-5 flex flex-wrap items-end gap-x-8 gap-y-4">
                                    <div>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-hdred">Retail</p>
                                        <p className="font-mono text-xl md:text-2xl text-hdred line-through decoration-2">$1,049</p>
                                    </div>
                                    <div>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">Karagna.com</p>
                                        <p className="font-display text-4xl md:text-5xl font-extrabold text-gold">$749</p>
                                    </div>
                                    <span className="rounded-full bg-save/15 border border-save/40 px-4 py-2 font-mono text-xs font-bold text-save">
                                        YOU SAVE $300 — 29%
                                    </span>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>

                {/* 02 — THE BRANDS */}
                <div data-testid="manifesto-chapter-02" className="mt-28 md:mt-40">
                    <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
                        <Reveal className="lg:col-span-3">
                            <span className="font-serifed italic font-light text-gold text-7xl md:text-8xl leading-none">02</span>
                            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">
                                The Brands
                            </p>
                        </Reveal>
                        <Reveal delay={0.1} className="lg:col-span-9">
                            <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-5xl leading-[1.02]">
                                Six names. Zero compromises.
                            </h2>
                        </Reveal>
                    </div>
                    <div>
                        {BRANDS.map((b, i) => (
                            <Reveal key={b} delay={i * 0.05}>
                                <div className="group flex items-baseline justify-between border-t border-white/10 py-5 md:py-7 transition-all duration-500 hover:pl-3 md:hover:pl-6 hover:border-gold/40">
                                    <span className="font-display font-bold tracking-tight text-3xl sm:text-5xl md:text-6xl text-white/70 transition-colors duration-500 group-hover:text-gold">
                                        {b}
                                    </span>
                                    <span className="font-mono text-xs text-slate-600 group-hover:text-gold transition-colors">
                                        0{i + 1}
                                    </span>
                                </div>
                            </Reveal>
                        ))}
                        <div className="border-t border-white/10" />
                    </div>
                </div>
            </div>
        </section>
    );
}
